import React from 'react';
import { FadeIn } from './FadeIn';

export default function BookingForm() {
  return (
    <section 
      id="booking-section" 
      className="py-24 md:py-32 bg-aged-ivory px-4 md:px-6 relative overflow-hidden"
    >
      <div className="max-w-[1180px] mx-auto relative z-10">
        <FadeIn className="text-center mb-12 md:mb-16">
          <span className="uppercase tracking-[0.5em] text-estate-bronze text-[10px] font-bold mb-5 block">
            Secure Your Date
          </span>
          <h2 className="text-4xl md:text-6xl lg:text-7xl text-deep-charcoal mb-8 leading-[1.1]">
            Reserve Your Private Tour
          </h2>
          <p className="text-lg md:text-xl text-deep-charcoal/60 font-light max-w-3xl mx-auto leading-relaxed mb-8">
            Choose your preferred date and time below. During your private tour, our team will guide you through the venue and build a personalized vision for your investment.
          </p>
          <div className="flex items-center justify-center gap-4 text-xs tracking-[0.2em] uppercase text-estate-bronze/70 font-bold italic">
            <span className="w-8 h-px bg-estate-bronze/30"></span>
            Private tours are approximately 1 hour
            <span className="w-8 h-px bg-estate-bronze/30"></span>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} className="relative">
          {/* 
            CLEAN LUXURY CONTAINER:
            - Background: #FCFAF6 (vintage-white)
            - Border: 1px solid rgba(217, 204, 186, 0.45)
            - Radius: 28px
            - Shadow: Professional soft elevation
          */}
          <div 
            className="w-full bg-vintage-white rounded-[28px] overflow-hidden border border-warm-stone/45 shadow-[0_18px_45px_rgba(47,43,40,0.07)]"
            style={{
              backgroundColor: '#FCFAF6',
              borderColor: 'rgba(217, 204, 186, 0.45)'
            }}
          >
            <div className="w-full relative overflow-hidden bg-transparent">
              <iframe 
                src="https://paduaweddings.fillout.com/padua-private-tour" 
                className="w-full h-[1500px] xs:h-[1350px] md:h-[950px] lg:h-[760px] transition-opacity duration-700"
                style={{ 
                  border: 'none', 
                  display: 'block', 
                  margin: '0 auto',
                  background: 'transparent'
                }} 
                frameBorder="0" 
                marginHeight="0" 
                marginWidth="0" 
                title="Padua Weddings Private Tour Booking"
                scrolling="no"
              ></iframe>
            </div>
          </div>
        </FadeIn>
      </div>

      {/* Responsive Height Logic for the Iframe */}
      <style dangerouslySetInnerHTML={{ __html: `
        @media (max-width: 480px) {
          #booking-section iframe { height: 1500px !important; }
        }
        @media (min-width: 481px) and (max-width: 767px) {
          #booking-section iframe { height: 1350px !important; }
        }
        @media (min-width: 768px) and (max-width: 1023px) {
          #booking-section iframe { height: 950px !important; }
        }
        @media (min-width: 1024px) {
          #booking-section iframe { height: 760px !important; }
        }
      `}} />
    </section>
  );
}